namespace app.support.dashboards {
    
    export interface DashboardLayout {
        rows: DashboardRow[]
    }

    export interface DashboardRow {
        columns: DashboardColumn[];
    }

    export interface DashboardColumn {
        dashlet: Dashlet;
    }
    
    export interface DashboardLayoutManager {
        layout(dashlets: Dashlet[], params?): DashboardLayout;
    }
    
    export interface DashboardLayoutManagerConfiguration {
        id: string;
        definition: DashboardLayoutManager;
    }

    export class DefaultDashboardLayoutManager implements DashboardLayoutManager {

        constructor() {

        }

        public layout(dashlets: Dashlet[]): DashboardLayout {
            let layout: DashboardLayout = {
                rows: []
            };
            if (dashlets && dashlets.length > 0) {
                let currentRow: DashboardRow;
                for (var i = 0; i < dashlets.length; i++) { // Monta um layout tabular de duas colunas.
                    if (i % 2 === 0) {
                        currentRow = {
                            columns: []
                        };
                        layout.rows.push(currentRow);
                        currentRow.columns.push({dashlet: dashlets[i]});
                    } else {
                        currentRow.columns.push({dashlet: dashlets[i]});
                    }
                }
            }
            return layout;
        }

    }
    
    export class DashboardLayoutManagerRegistry {
        
        private registeredLayoutManagers: DashboardLayoutManagerConfiguration[] = [];

        
        public registerLayoutManager(id: string, layoutManager: DashboardLayoutManager): DashboardLayoutManagerRegistry {
            this.registeredLayoutManagers.push(<DashboardLayoutManagerConfiguration>{id: id, definition: layoutManager});
            return this;
        }
        
        public recoverLayoutManager(id: string): DashboardLayoutManager {
            for (let layoutManagers of this.registeredLayoutManagers) {
                if (layoutManagers.id === id) {
                    return layoutManagers.definition;
                }
            }
            throw new Error("Layout Manager " + id + " não foi encontrado.");
        }
        
    }
    
    angular.module('app.support.dashboards').service('dashboardLayoutManagerRegistry', DashboardLayoutManagerRegistry);
    
    angular.module('app.support.dashboards').run((dashboardLayoutManagerRegistry: DashboardLayoutManagerRegistry) => {
        "ngInject";
        dashboardLayoutManagerRegistry.registerLayoutManager("default", new DefaultDashboardLayoutManager());
    });

}